// extracted by mini-css-extract-plugin
export default {"pagination":"paginationAlt_pagination__+o-cp"};